import { useState } from "react";
import moment from "moment";
import { ColumnDescription } from "react-bootstrap-table-next";

import "moment/locale/pt-br";

import {
    faDollarSign,
    faFileArchive,
    faPhone,
} from "@fortawesome/free-solid-svg-icons";

import Table from "../../../../../Table";
import ModalComponent from "../../../../../Modais";
import { IComponentModal } from "../../../../../Modais/IModalComponent";
import AtendimentoCard, { ModuloAtendimento } from "../../../../Atendimento";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ListarAtendimentosController } from "../../../../../../Controllers/Cobranca/GestaoAtendimento/GestaoAtendimentoController";
import { IAtendimentoCobranca } from "../../../../../../Interfaces/Cobranca/GestaoAtendimento/GestaoAtendimentoInterface";
import { formatMoneyReais } from "../../../../../../Tools/FormatTools";
import useAsyncEffect from "../../../../../../hooks/useAsyncEffect";
import usePaginationFilter from "../../../../../../hooks/usePaginationFilter";
import FiltroAtendimentosDoCliente from "../FiltroAtendimentosDoCliente";

interface FilterFormDataInterface {
    data_inicio: string;
    data_fim: string;
    busca?: string;
    DS_STATUS_CASO?: number;
    ID_EMPREENDIMENTO?: number;
    ID_PRODUTO?: number;
    ID_UNIDADE?: number;
    ID_USUARIO?: number;
    ID_CASO?: number;
    DS_NOME_CONTA?: string;
    DS_NOME_CONTATO?: string;
    ID_TIPO_CANAL_ATENDIMENTO?: number;
    PESQUISA?: string;
    FL_CONTEM?: boolean;
}

interface IAtendimentosCobrancaProps {
    ID_CONTA: number;
    dsModulo: ModuloAtendimento;
}

/**
 * RCF - mostra uma lista de atendimentos com interface reduzida de atendimentos de uma conta específica
 * @param props.ID_CONTA cliente cujos atendimentos quer mostrar
 * @returns JSX com os atendimento do módulo de cobranca do cliente
 */
export default function AtendimentosCobrancaDaConta(
    props: IAtendimentosCobrancaProps
) {
    moment.locale("pt-br");

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const [valueEtapa, setValueEtapa] = useState<Array<{
        label: string;
        value: number;
    }> | null>(null);

    const [categoriaAtendimento, setCategoriaAtendimento] = useState<number[]>(
        []
    );

    const handleDateChange = (formData: FilterFormDataInterface) => {
        const filterFormData = {
            ...formData,
        };
        PageFilter.page = 1;
        setFilter(filterFormData);
        sessionStorage.setItem(
            "FILTRO_ATENDIMENTOS_DO_CLIENTE",
            JSON.stringify(filterFormData)
        );
    };

    const FILTRO_ATENDIMENTOS_DO_CLIENTE_COBRANCA = sessionStorage.getItem(
        "FILTRO_ATENDIMENTOS_DO_CLIENTE_COBRANCA"
    );

    const filtroInicial = {
        DT_INICIAL_IN: "",
        DT_INICIAL_FN: "",
        DT_FINAL_IN: "",
        DT_FINAL_FN: "",
        DS_STATUS_CASO: "",
        ID_MOTIVO_CANCELAMENTO: 0,
        ID_UNIDADE: 0,
        ID_PRODUTO: 0,
        FL_ANDAMENTO: 0,
        FL_CONTEM: false,
        PESQUISA: "",
        ID_USUARIO: 0,
        DS_NOME_CONTA: "",
        DS_NOME_CONTATO: "",
        ID_CATEGORIA_ATENDIMENTO: [0],
        ID_TIPO_CANAL_ATENDIMENTO: 0,
        ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASOS: 0,
        ID_TIPOS_PESOS_ATENDIMENTOS: [0],
        ID_CONTA: props.ID_CONTA,
        ID_ACOMPANHAMENTO: 0,
    };

    const { PageFilter, setPage, filter, setFilter } =
        usePaginationFilter<FilterFormDataInterface>({
            page: 1,
            filter: FILTRO_ATENDIMENTOS_DO_CLIENTE_COBRANCA
                ? JSON.parse(FILTRO_ATENDIMENTOS_DO_CLIENTE_COBRANCA)
                : filtroInicial,
        });

    const {
        value: lstAtendimentosCobranca,
        loading: lstAtendimentosCobrancaLoading,
    } = useAsyncEffect(
        () =>
            ListarAtendimentosController(
                {
                    ID_CONTA: props.ID_CONTA,
                    DT_PERIODO_FIM: filter?.data_fim,
                    DT_PERIODO_INICIO: filter?.data_inicio,
                    ID_EMPREENDIMENTO: filter?.ID_EMPREENDIMENTO,
                    ID_UNIDADE: filter?.ID_UNIDADE,
                    FL_STATUS:
                        filter?.DS_STATUS_CASO === 0
                            ? false
                            : filter?.DS_STATUS_CASO === 1
                            ? true
                            : undefined,

                    DS_STATUS_CASO: filter?.DS_STATUS_CASO,
                    ID_CASO: filter?.ID_CASO ?? undefined,
                    ID_USUARIO: filter?.ID_USUARIO,
                    NR_PAGINA: PageFilter.page,
                },
                "GERAL"
            ),
        [props.ID_CONTA, PageFilter, filter]
    );

    const totalPaginas = lstAtendimentosCobranca?.NR_TOTAL_PAGINAS
        ? lstAtendimentosCobranca?.NR_TOTAL_PAGINAS
        : 1;

    function rowAtendimento(cell: any, row: IAtendimentoCobranca) {
        return (
            <AtendimentoCard
                atendimento={row}
                moduloAtendimento={props.dsModulo}
                setModal={setModal}
                setShow={setShow}
                compactar={true}
            >
                <span
                    className="label label-light-info label-inline mr-2 my-1"
                    style={{ height: "auto" }}
                >
                    <FontAwesomeIcon icon={faDollarSign} className="mr-1" />{" "}
                    Valor em aberto -{" "}
                    {row.COBRANCA.NR_PARCELAS_EM_ABERTO_ABERTURA} x{" "}
                    {formatMoneyReais(
                        row.COBRANCA.VL_PARCELAS_EM_ABERTO_ABERTURA
                    )}
                </span>
                <span
                    className="label label-light-info label-inline mr-2 my-1"
                    style={{ height: "auto" }}
                >
                    <FontAwesomeIcon icon={faPhone} className="mr-1" />{" "}
                    {row.COBRANCA.DS_RESULTADO_CONTATO}
                </span>
                <span
                    className="label label-light-info label-inline mr-2 my-1"
                    style={{ height: "auto" }}
                >
                    <FontAwesomeIcon icon={faFileArchive} className="mr-1" />{" "}
                    Classificação{" "}
                    {row.COBRANCA.DS_CLASSIFICACAO_CONTRATO_ABERTURA}{" "}
                    {row.COBRANCA.DS_STATUS_ESCRITURA_ABERTURA}
                </span>
            </AtendimentoCard>
        );
    }
    //tabela
    const atendimentoColumns: Array<ColumnDescription> = [
        {
            dataField: "ID_CASO",
            text: "",
            formatter: rowAtendimento,
        },
    ];

    return (
        <>
            <div className="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                <div className="d-flex align-items-center justify-content-start">
                    <h4 className="text-dark font-weight-bold my-1 mr-5">
                        Atendimentos Cobrança
                    </h4>
                </div>
            </div>
            <Table
                columns={atendimentoColumns}
                data={lstAtendimentosCobranca?.LISTA_ATENDIMENTOS ?? []}
                keyField="ID_CASO"
                onTableChange={(type, newState) => {
                    setPage(newState.page);
                }}
                remote={{ pagination: true }}
                totalPages={totalPaginas}
                loading={lstAtendimentosCobrancaLoading}
                noDataIndication={() => (
                    <div className="text-black-50 text-center">
                        Nenhum Atendimento encontrado
                    </div>
                )}
                noHover
                noSearch
                bordered={false}
            />
            <FiltroAtendimentosDoCliente
                FILTRO_ATENDIMENTOS_DO_CLIENTE={
                    FILTRO_ATENDIMENTOS_DO_CLIENTE_COBRANCA
                }
                filter={filter}
                filtroInicial={filtroInicial}
                handleDateChange={handleDateChange}
                setFilter={setFilter}
                setPage={setPage}
                setIdEmpreendimento={() => {}}
                setCategoriaAtendimento={setCategoriaAtendimento}
                categoriaAtendimento={categoriaAtendimento}
                setValueEtapa={setValueEtapa}
                valueEtapa={valueEtapa}
                dsModulo={props.dsModulo}
            />

            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </>
    );
}
